export default "__VITE_ASSET__CXuhU0kO__"